import { Component, Injectable, OnInit, Input } from '@angular/core';
@Component({
    selector: 'design-tile',
    templateUrl: './designtile.component.html'
})

@Injectable()
export class DesignTile implements OnInit {
    static tile_id = 0;
    designOptions: any;
    data: any;
    lgPrev: boolean = false;
    designData: any;
    total = {
        fTotal: 0,
        hTotal: 0,
        TotPcs: 0
    };
    @Input()
    set options(val: string) {
        this.designOptions = Object.assign(this.designOptions, val);
        this.designData = Object.assign(this.designOptions, val);
        this.start();
        //  this.calcTotal();
    }
    get options() {
        return this.designOptions;
    }
    tileID: number;
    constructor() {
        this.tileID = DesignTile.tile_id++;
        this.designOptions = {
            tile_id: this.tileID
        }
        this.designData = {
            cols: [],
            data: [],
            groupby: ''
        }
    }
    ngOnInit() {
        // console.log('DesignTile-' + this.tileID + ' Created.');
        this.calcTotal();
    }

    calcTotal() {
        let design = this.designData.data;
        if (this.designData.filter == 'F' || this.designData.name=='Delivery' || this.designData.name=='Order') {
            let ftot = 0, htot = 0;
            for (let i = 0; i < design.length; i++) {
                let data = design[i];
                if(data.f34 == undefined || data.h34 == undefined){
                    data.f34 = 0;data.h34 = 0;
                }
                ftot += data.f34 + data.f36 + data.f38 + data.f40 + data.f42 + data.f44;
                htot += data.h34 + data.h36 + data.h38 + data.h40 + data.h42 + data.h44;
            }
            this.total.fTotal = ftot;
            this.total.hTotal = htot;
            this.total.TotPcs = this.total.fTotal + this.total.hTotal;
            return this.total;
        } else if (this.designData.filter == 'DAMAGE') {
            let ftot = 0, htot = 0;
            for (let i = 0; i < design.length; i++) {
                let data = design[i];
                ftot += data.AF34 + data.AF36 + data.AF38 + data.AF40 + data.AF42 + data.AF44;
                htot += data.AH34 + data.AH36 + data.AH38 + data.AH40 + data.AH42 + data.AH44;
            }
            this.total.fTotal = ftot;
            this.total.hTotal = htot;
            this.total.TotPcs = this.total.fTotal + this.total.hTotal;
            return this.total;
        } else {
            let ftot = 0, htot = 0;
            for (let i = 0; i < design.length; i++) {
                let data = design[i];
                ftot += data.AF34 + data.AF36 + data.AF38 + data.AF40 + data.AF42 + data.AF44;
                htot += data.AH34 + data.AH36 + data.AH38 + data.AH40 + data.AH42 + data.AH44;
            }
            this.total.fTotal = ftot;
            this.total.hTotal = htot;
            this.total.TotPcs = this.total.fTotal + this.total.hTotal;
            return this.total;
        }

    }

    start() {
        this.data = '';
    }
    setData(data) {
        this.data = data;
      
    }

}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/common/designtile/designtile.component.ts